import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { atendimentoEndpoint, type AtendimentoConfig } from '../types';

type Input = { slug: string };

// Configuração do atendimento da loja. O modo (cliente/assistido) é decidido
// pelo backend a partir do token enviado.
export class GetAtendimentoConfigUseCase implements IUseCase<Input, AtendimentoConfig> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute({ slug }: Input): Promise<AtendimentoConfig> {
    const response = await this.client.sendRequest<{ data: AtendimentoConfig }, never>({
      endpoint: atendimentoEndpoint(slug),
      method: HttpMethod.GET,
    });

    return {
      ...response.data,
      pagamentos_offline: response.data.pagamentos_offline ?? [],
    };
  }
}
